unit unit_NeueMitteilung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, DB, Vcl.Controls, WEBLib.Grids, Vcl.StdCtrls,
  WEBLib.StdCtrls, strutils, XData.Web.Client;

type
  TNeueMitteilung = class(TForm)
    dspersonal: TXDataWebDataSet;
    dspersonalPersonalnummer: TIntegerField;
    dspersonalNachname: TStringField;
    dspersonalVorname: TStringField;
    TC: TTableControl;
    btnzurueck: TButton;
    lookupEmpfaenger: TComboBox;
    edtNotiz: TMemo;
    btnsenden: TButton;
    edtBetreff: TEdit;
    WClient: TXDataWebClient;
    procedure WebFormShow(Sender: TObject);
    procedure dspersonalAfterOpen(DataSet: TDataSet);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnsendenClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  NeueMitteilung: TNeueMitteilung;

implementation
  uses unit1, unit2, unit_Mitteilungen;
{$R *.dfm}

procedure TNeueMitteilung.btnsendenClick(Sender: TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
  ergebnis:string;
  begin
    ergebnis:=string(TJSObject(response.Result)['value']);
    if ergebnis='WRONG' then
    begin
      showmessage('Die Mitteilung konnte leider nicht erstellt werden');
    end
    else
    begin
      dspersonal.Close;
      self.close;
    end;
  end;
var
  tmpEmpfaenger:string;
  tmpstringlist:TStringList;
begin
  if edtBetreff.Text='' then
  begin
    showmessage('Sie haben keinen Betreff eingetragen.');
    exit;
  end;
  if edtNotiz.Text='' then
  begin
    showmessage('Sie haben keine Notiz eingetragen.');
    exit;
  end;
  if lookupEmpfaenger.Text='' then
  begin
    showmessage('Sie haben keinen Empfänger ausgewählt.');
    exit;
  end;
  tmpstringlist:=TStringList.Create;
  tmpstringlist.Delimiter:='|';
  tmpstringlist.StrictDelimiter:=true;
  tmpstringlist.DelimitedText:=lookupEmpfaenger.Text;
  tmpEmpfaenger:=trim(tmpstringlist[0]);
  WClient.RawInvoke('IServerService.NeueMitteilung',[BenutzerPersonalnummer,tmpEmpfaenger,edtBetreff.Text,'',edtnotiz.text],@OnResponse);
end;

procedure TNeueMitteilung.btnzurueckClick(Sender: TObject);
begin
  dspersonal.Close;
  self.close;
end;

procedure TNeueMitteilung.dspersonalAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  i:=0;
  TC.ColCount:=1;
  tc.rowcount:=10;
  TC.Cells[0,i]:='<h4>Neue Mitteilung';


  inc(i);
  myelement:=TC.cellelements[0,i];
  btnzurueck.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Empfänger wählen:';
  inc(i);
  myelement:=TC.cellelements[0,i];
  lookupEmpfaenger.ParentElement:=myelement;

  dspersonal.First;
  while not dspersonal.eof do
  begin
    if dspersonalPersonalnummer.AsString<>BenutzerPersonalnummer then
    begin
      lookupEmpfaenger.Items.Add(dspersonalPersonalnummer.AsString+' | '+dspersonalnachname.AsString +' | '+dspersonalVorname.asstring);
    end;
    dspersonal.Next;
  end;
  inc(i);
  TC.Cells[0,i]:='Betreff:';
  inc(i);
  myelement:=TC.cellelements[0,i];
  edtBetreff.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Notiz:';
  inc(i);
  myelement:=TC.cellelements[0,i];
  edtNotiz.ParentElement:=myelement;
  inc(i);
  myelement:=TC.cellelements[0,i];
  btnsenden.ParentElement:=myelement;
end;

procedure TNeueMitteilung.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action:=cafree;
end;

procedure TNeueMitteilung.WebFormShow(Sender: TObject);
begin
  dspersonal.Load;
end;

procedure TNeueMitteilung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  btnzurueck := TButton.Create(Self);
  lookupEmpfaenger := TComboBox.Create(Self);
  edtNotiz := TMemo.Create(Self);
  btnsenden := TButton.Create(Self);
  edtBetreff := TEdit.Create(Self);
  dspersonal := TXDataWebDataSet.Create(Self);
  dspersonalPersonalnummer := TIntegerField.Create(Self);
  dspersonalNachname := TStringField.Create(Self);
  dspersonalVorname := TStringField.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  lookupEmpfaenger.BeforeLoadDFMValues;
  edtNotiz.BeforeLoadDFMValues;
  btnsenden.BeforeLoadDFMValues;
  edtBetreff.BeforeLoadDFMValues;
  dspersonal.BeforeLoadDFMValues;
  dspersonalPersonalnummer.BeforeLoadDFMValues;
  dspersonalNachname.BeforeLoadDFMValues;
  dspersonalVorname.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'NeueMitteilung';
    Width := 269;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.AlignWithMargins := True;
    TC.Left := 3;
    TC.Top := 3;
    TC.Width := 263;
    TC.Height := 474;
    TC.ElementClassName := 'table table-bordered';
    TC.Align := alClient;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-bordered';
    TC.WordWrap := True;
    TC.ColCount := 1;
    TC.RowCount := 5;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 67;
    btnzurueck.Top := 141;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    lookupEmpfaenger.SetParentComponent(Self);
    lookupEmpfaenger.Name := 'lookupEmpfaenger';
    lookupEmpfaenger.Left := 40;
    lookupEmpfaenger.Top := 56;
    lookupEmpfaenger.Width := 177;
    lookupEmpfaenger.Height := 23;
    lookupEmpfaenger.ChildOrder := 1;
    lookupEmpfaenger.ElementClassName := 'form-control w-90 m-1';
    lookupEmpfaenger.ElementFont := efCSS;
    lookupEmpfaenger.ElementPosition := epIgnore;
    lookupEmpfaenger.HeightStyle := ssAuto;
    lookupEmpfaenger.HeightPercent := 100.000000000000000000;
    lookupEmpfaenger.Text := 'lookupEmpfaenger';
    lookupEmpfaenger.TextHint := 'bitte ausw'#228'hlen';
    lookupEmpfaenger.WidthStyle := ssPercent;
    lookupEmpfaenger.WidthPercent := 95.000000000000000000;
    lookupEmpfaenger.ItemIndex := -1;
    edtNotiz.SetParentComponent(Self);
    edtNotiz.Name := 'edtNotiz';
    edtNotiz.Left := -83;
    edtNotiz.Top := 266;
    edtNotiz.Width := 352;
    edtNotiz.Height := 135;
    edtNotiz.ElementClassName := 'form-control w-90 m-1';
    edtNotiz.ElementFont := efCSS;
    edtNotiz.ElementPosition := epIgnore;
    edtNotiz.HeightPercent := 100.000000000000000000;
    edtNotiz.SelLength := 0;
    edtNotiz.SelStart := 0;
    edtNotiz.TextHint := 'Mitteilung eingeben';
    edtNotiz.WidthStyle := ssPercent;
    edtNotiz.WidthPercent := 95.000000000000000000;
    btnsenden.SetParentComponent(Self);
    btnsenden.Name := 'btnsenden';
    btnsenden.Left := 67;
    btnsenden.Top := 203;
    btnsenden.Width := 96;
    btnsenden.Height := 25;
    btnsenden.Caption := 'senden';
    btnsenden.ChildOrder := 4;
    btnsenden.ElementClassName := 'btn btn-info m-1 text-left';
    btnsenden.ElementFont := efCSS;
    btnsenden.ElementPosition := epIgnore;
    btnsenden.HeightStyle := ssAuto;
    btnsenden.HeightPercent := 100.000000000000000000;
    btnsenden.WidthStyle := ssAuto;
    btnsenden.WidthPercent := 100.000000000000000000;
    SetEvent(btnsenden, Self, 'OnClick', 'btnsendenClick');
    edtBetreff.SetParentComponent(Self);
    edtBetreff.Name := 'edtBetreff';
    edtBetreff.Left := 42;
    edtBetreff.Top := 175;
    edtBetreff.Width := 121;
    edtBetreff.Height := 22;
    edtBetreff.ChildOrder := 5;
    edtBetreff.ElementClassName := 'form-control w-90 m-1';
    edtBetreff.ElementFont := efCSS;
    edtBetreff.ElementPosition := epIgnore;
    edtBetreff.HeightStyle := ssAuto;
    edtBetreff.HeightPercent := 100.000000000000000000;
    edtBetreff.TextHint := 'Betreff eingeben';
    edtBetreff.WidthStyle := ssPercent;
    edtBetreff.WidthPercent := 95.000000000000000000;
    dspersonal.SetParentComponent(Self);
    dspersonal.Name := 'dspersonal';
    dspersonal.AfterOpen := dspersonalAfterOpen;
    dspersonal.EntitySetName := 'Personal';
    dspersonal.Connection := DM2.XDataWebConnection1;
    dspersonal.QueryString := '$filter=enabled eq True';
    dspersonal.Left := 121;
    dspersonal.Top := 183;
    dspersonalPersonalnummer.SetParentComponent(dspersonal);
    dspersonalPersonalnummer.Name := 'dspersonalPersonalnummer';
    dspersonalPersonalnummer.FieldName := 'Personalnummer';
    dspersonalPersonalnummer.Required := True;
    dspersonalNachname.SetParentComponent(dspersonal);
    dspersonalNachname.Name := 'dspersonalNachname';
    dspersonalNachname.FieldName := 'Nachname';
    dspersonalNachname.Required := True;
    dspersonalNachname.Size := 40;
    dspersonalVorname.SetParentComponent(dspersonal);
    dspersonalVorname.Name := 'dspersonalVorname';
    dspersonalVorname.FieldName := 'Vorname';
    dspersonalVorname.Size := 40;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 88;
    WClient.Top := 8;
  finally
    TC.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    lookupEmpfaenger.AfterLoadDFMValues;
    edtNotiz.AfterLoadDFMValues;
    btnsenden.AfterLoadDFMValues;
    edtBetreff.AfterLoadDFMValues;
    dspersonal.AfterLoadDFMValues;
    dspersonalPersonalnummer.AfterLoadDFMValues;
    dspersonalNachname.AfterLoadDFMValues;
    dspersonalVorname.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.
